export default __webpack_public_path__ + "static/media/WebDev.97146929.PNG";